"use client";

import { c as _c } from "react/compiler-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { SearchSelect, SearchSelectContent, SearchSelectItem, SearchSelectTrigger, SearchSelectValue } from "@/components/ui/select";
import { formatToHumanReadable } from "@/lib/format-data";
import { Gender } from "@/types/enums/gender";
export default function GenderField(t0) {
  const $ = _c(11);
  const {
    className,
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    control,
    formState: t2
  } = useFormContext();
  const {
    errors
  } = t2;
  const errorMessage = errors.gender?.message as string | undefined;
  const t3 = required && "Gender is required";
  let t4;
  if ($[0] !== t3) {
    t4 = {
      required: t3
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== errorMessage) {
    t5 = t6 => {
      const {
        field
      } = t6;
      return <SearchSelect value={field.value || ""} onValueChange={field.onChange}><SearchSelectTrigger className="mt-1 w-full" hasError={!!errorMessage} errorMessage={errorMessage}><SearchSelectValue placeholder="Select gender" formatValue={formatToHumanReadable} /></SearchSelectTrigger><SearchSelectContent searchPlaceholder="Search gender..." emptyMessage="No gender found.">{Object.values(Gender).map(_temp)}</SearchSelectContent></SearchSelect>;
    };
    $[2] = errorMessage;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== control || $[5] !== t4 || $[6] !== t5) {
    t6 = <Controller name="gender" control={control} rules={t4} render={t5} />;
    $[4] = control;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== className || $[9] !== t6) {
    t7 = <div className={className}>{t6}</div>;
    $[8] = className;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp(gender) {
  return <SearchSelectItem key={gender} value={gender}>{formatToHumanReadable(gender)}</SearchSelectItem>;
}